export function playSoundEffect(importedSoundEffect: any, volumeAsNumberBetween0and1: number): void{
    if(volumeAsNumberBetween0and1 > 1 || volumeAsNumberBetween0and1 < 0){
       throw new Error("volume number is not in a range between 0 and 1");
    }
    window.setTimeout(() => {
        const audio = new Audio(importedSoundEffect);
        audio.volume = volumeAsNumberBetween0and1;
        audio.play();
    });
}